import { InboxView } from "../types";
import type { InboxThread } from "@tellescope/types-models";

/**
 * Builds a URL path for a messaging thread.
 *
 * @param params - The parameters for building the link
 * @param params.view - The inbox view (e.g., "inbox", "sent", "drafts")
 * @param params.channel - The thread type (e.g., "Email", "SMS", "Chat")
 * @param params.threadId - The thread ID
 * @param params.draftId - Optional draft ID. If provided, adds ?draftId query parameter
 * @returns The constructed URL path with optional query parameters
 */
export const buildMessagingThreadLink = ({
  view,
  channel,
  threadId,
  draftId,
}: {
  view: InboxView;
  channel: InboxThread["type"];
  threadId: string;
  draftId?: string;
}): string => {
  const basePath = `/messaging/${view}/${channel.toLowerCase()}/${threadId}`;
  const queryParam = draftId ? `?draftId=${draftId}` : "";
  return `${basePath}${queryParam}`;
};
